import * as Sentry from '@sentry/browser';
const isDev = process.env.NODE_ENV === 'development';

interface ErrorLogger {
  name: string;
  message: string;
  devOnly?: boolean;
}

export default function({ name, message, devOnly }: ErrorLogger) {
  const err = new Error(`PROJECT: portal-paywall. ERROR MESSAGE: ${message}`);
  err.name = name;

  // Create fatal error in dev mode
  if (isDev) {
    throw err;
  }

  if (devOnly) {
    return;
  }

  // Send error message to Sentry
  // https://sentry.delfi.net/sentry/portal-paywall/
  Sentry.captureException(err);
}
